import React, { Component } from 'react'
import { Container, Title, ContentContainer, Content, Button, Wrapper, ContentWrapper } from './styles'

class FullScreenCTA extends Component {
  render() {
    const { title, image, children, link, mobileImage } = this.props
    return (
      <Container image={image} mobileImage={mobileImage}>
        <Wrapper>
          <Title>{title}</Title>
          <ContentContainer>
            <ContentWrapper>
              <Content>{children}</Content>
              <Button href={link.url} target="_blank">
                {link.content}
              </Button>
            </ContentWrapper>
          </ContentContainer>
        </Wrapper>
      </Container>
    )
  }
}

export default FullScreenCTA



// WEBPACK FOOTER //
// ./src/components/FullScreenCTA/index.js